module.exports = __webpack_public_path__ + "static/wellness_pc-da892e4724ffcd27700fb8d26028a394.png";